import React from "react";
import { Route, Switch, useRouteMatch, NavLink } from "react-router-dom";
import clsx from "clsx";
import Today from "./Today/Today";
import All from "./All/All";
import Overdue from "./Overdue/Overdue";
import { useTranslation } from "react-i18next";

const VisitorLog = React.memo(() => {
  const { t } = useTranslation(["visitorLogs", "common"]);
  const match = useRouteMatch();
  return (
    <div className="container-fluid">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb my-3">
          <li className="breadcrumb-item active" aria-current="page">
            {t("visitorLogs:visitorLogs.nav.visitorLogs")}
          </li>
        </ol>
      </nav>
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <NavLink exact className="nav-link" to={match.url}>
            {t("visitorLogs:visitorLogs.nav.today")}
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink
            exact
            className={clsx("nav-link")}
            to={`${match.url}/overdue`}
          >
            {t("visitorLogs:visitorLogs.nav.overdue")}
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink className={clsx("nav-link")} to={`${match.url}/all`}>
            {t("visitorLogs:visitorLogs.nav.all")}
          </NavLink>
        </li>
      </ul>

      <div className="tab-content">
        <Switch>
          <Route path={`${match.path}/overdue`}>
            <div className="tab-pane active" role="tabpanel">
              <Overdue />
            </div>
          </Route>
          <Route path={`${match.path}/all`}>
            <div className="tab-pane active" role="tabpanel">
              <All />
            </div>
          </Route>
          <Route path={match.path}>
            <div className="tab-pane active" role="tabpanel">
              <Today />
            </div>
          </Route>
        </Switch>
      </div>
    </div>
  );
});

export default VisitorLog;
